import { useQuery } from "@tanstack/react-query";
import QueryGlobalInterface from "interfaces/queryInterface";
import { toast } from "react-toastify";
import instance from "services/axiosServices";

export function useListarBairrosEmpreendimentos(props: QueryGlobalInterface) {
  const fetchData = async () => {
    const LISTAR_BAIRROS_EMPRENDIMENTOS = `/locais/mobile/bairros-empreendimentos/Regional/v1`;
    const response = await instance.get(LISTAR_BAIRROS_EMPRENDIMENTOS);
    const dataWithPagination = {
      data: response?.data?.data,
      pagination: response?.data?.pagination,
    };
    return dataWithPagination;
  };
  const query = useQuery({
    queryFn: () => fetchData(),
    queryKey: [props.queryKey],
    refetchOnWindowFocus: false,
    enabled: true,
    retry: false,
    onError: (error: any) => {
      toast.error(
        `Erro ao listar "Bairros". Motivos:\n ${error.response.data.notifications.map(
          (item: any) => `${item?.message}`
        )} `,
        { autoClose: 10000 }
      );
    },
  });
  return query;
}
